function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useContext, useEffect, useState } from 'react';
import { ClosestElementRegistryContext, IAppContext } from "noood/contexts/contexts";
export default function ClosestElementRegistry(props) {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectors = _useState2[0],
    set_selectors = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    callbacks = _useState4[0],
    set_callbacks = _useState4[1];
  var _useState5 = useState(new Set()),
    _useState6 = _slicedToArray(_useState5, 2),
    registeredRefs = _useState6[0],
    setRegisteredRefs = _useState6[1];
  var __register = function __register(selector, callback) {
    // console.log("Registering listener for: " + selector)

    var current_selectors = selectors;
    current_selectors.push(selector);
    set_selectors(current_selectors);

    // register callbacks
    var current_callbacks = callbacks;
    current_callbacks[selector] = callback;
    set_callbacks(current_callbacks);
  };
  var __registerRef = function __registerRef(_ref) {
    var ref = _ref.ref,
      callback = _ref.callback;
    console.log(registeredRefs);
    registeredRefs.add(ref.id);
  };
  var __close_all = function __close_all() {
    return new Promise(function (resolve, reject) {
      try {
        Object.keys(callbacks).forEach(function (callback_key, idx) {
          var _callbacks$callback_k;
          // console.log('calling callback for: ' + callback_key)
          (_callbacks$callback_k = callbacks[callback_key]) === null || _callbacks$callback_k === void 0 || _callbacks$callback_k.call(callbacks);
        });
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  };
  useEffect(function () {
    console.log("The list of registered refs is now: ", registeredRefs);
  }, [registeredRefs]);
  var __listener = function __listener(e) {
    var not_null = 0;
    if (selectors && Array.isArray(selectors) && selectors.length > 0) {
      var selectorsForDeletion = []; // delete selector list
      selectors.forEach(function (selector, idx) {
        try {
          if (e.target.closest(selector) === null) {
            selectorsForDeletion.push(selector);
          } else {
            not_null++;
          }
        } catch (er) {}
      });
      if (not_null === 0) {
        Object.keys(callbacks).forEach(function (callback_key, idx) {
          var _callbacks$callback_k2;
          (_callbacks$callback_k2 = callbacks[callback_key]) === null || _callbacks$callback_k2 === void 0 || _callbacks$callback_k2.call(callbacks);
          delete callbacks[callback_key];
        });
      }
      selectorsForDeletion.forEach(function (selector) {
        delete selectorsForDeletion[selector];
      });
      set_selectors(selectorsForDeletion);
    }
  };
  useEffect(function () {
    document.addEventListener('mouseup', __listener);
    return function () {
      document.removeEventListener('mouseup', __listener);
    };
  }, []);
  return /*#__PURE__*/React.createElement(ClosestElementRegistryContext.Provider, {
    value: {
      __register: __register,
      __close_all: __close_all,
      __registerRef: __registerRef
    }
  }, props.children);
}
export function useClosestElementRegistry() {
  var context = useContext(ClosestElementRegistryContext);
  // Error handling if used outside provider
  if (context === undefined) {
    throw new Error('useClosestElementRegistry must be used within a ClosestElementRegistry');
  } else {}
  return context;
}